import { combineReducers } from 'redux'
import user from '../reducers/user'
import devicesPage from '../reducers/devicesPage.reducer'
import { reducer as toastrReducer } from 'react-redux-toastr'

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    user,
    devicesPage,
    toastr: toastrReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
